/* eslint-disable import/no-cycle */
import ImageTextSideBySide from 'components/ImageTextSideBySide';
import { logger } from '../../utils';
import { CType } from '../../models/Contentful/types';
import { IImageTextSideBySideBladeProps } from './@types';

const ImageTextSideBySideBlade: React.FC<CType<IImageTextSideBySideBladeProps>> = props => {
  try {
    const {
      fields: { ...data },
    } = props;

    return <ImageTextSideBySide {...data} />;
  } catch (error) {
    logger.error(error);
    return null;
  }
};
export default ImageTextSideBySideBlade;
